<div class="lio-card">
    <div class="preview-img">
        <img *ngIf="this.event?.image" class="img-background-cover full" src="{{this.event?.image.url}}" alt="">
        <img *ngIf="!this.event?.image" class="img-background-cover full"
            src="../../../../assets//placeholders/eventImage.png" alt="">

    </div>
    <div class="background-white">
        <div class="content inner-margin">

            <div class="additional-info highlight"
                *ngIf="(this.event?.eventDiscount !='SERVICE_PLUS')&& (this.event?.savingInPercent != null)">
                {{event?.discountLabel}}
            </div>

            <div class="additional-info highlight" *ngIf="(this.event?.eventDiscount =='SERVICE_PLUS')">
                Exklusiv
            </div>

            <h4 class="minHeight40" *ngIf="this.event?.title">
                {{this.event?.title | truncate : 40 : false}}</h4>



            <h5 *ngIf="this.event?.start == null" class="additional-info-big">Unbegrenzt </h5>
            <h5 *ngIf="this.event?.start != null" class="additional-info-big">{{this.event?.start | date:'dd.MM.yyyy' }}
                bis {{this.event?.end |
                date:'dd.MM.yyyy'}} </h5>

            <h5 class="additional-info" *ngIf="this.event?.eventPartner">
                {{this.event?.eventPartner.name | truncate : 30 : true}}</h5>

        </div>
        <button class="previewBtn">
            Reservieren
        </button>
    </div>

</div>